import { api_url } from "../configiration/config";
import { axiosClone } from './../axiosClone';

//get all property details
export async function getPropertyDetails(propertySlug){
  return await axiosClone.get(`${api_url}/properties/${propertySlug}`);
}
// get all filtered propterties
export function filterProperties(data){
  return axiosClone.get(`${api_url}/properties?${data}`);
}